import { Stack } from "@mui/material";
import { type FC, useCallback, useLayoutEffect, useState } from "react";
import { useNotificationCenterRightOptional } from "web_myplann/Api/Rights/RightsProvider";
import { DashboardRecentSection } from "web_myplann/Dashboard/Components/DashboardRecentSection";
import { DashboardResolvingNowSection } from "web_myplann/Dashboard/Components/DashboardResolvingNowSection";
import { DashboardUpcomingSection } from "web_myplann/Dashboard/Components/DashboardUpcomingSection";
import { useIsDashboardV2 } from "web_myplann/Dashboard/State/dashboardVariantContext";

interface DashboardNotificationsSectionProps {
	onEmptyChange?: (isEmpty: boolean) => void;
}

export const DashboardNotificationsSection: FC<
	DashboardNotificationsSectionProps
> = ({ onEmptyChange }) => {
	const hasNotificationCenterRight = useNotificationCenterRightOptional();
	const isV2 = useIsDashboardV2();
	const [resolvingEmpty, setResolvingEmpty] = useState(false);
	const [upcomingEmpty, setUpcomingEmpty] = useState(false);
	const [recentEmpty, setRecentEmpty] = useState(false);

	const handleResolvingChange = useCallback((isEmpty: boolean) => {
		setResolvingEmpty(isEmpty);
	}, []);
	const handleUpcomingChange = useCallback((isEmpty: boolean) => {
		setUpcomingEmpty(isEmpty);
	}, []);
	const handleRecentChange = useCallback((isEmpty: boolean) => {
		setRecentEmpty(isEmpty);
	}, []);

	const allEmpty = resolvingEmpty && upcomingEmpty && recentEmpty;

	useLayoutEffect(() => {
		onEmptyChange?.(hasNotificationCenterRight ? allEmpty : true);
	}, [onEmptyChange, allEmpty, hasNotificationCenterRight]);

	if (!hasNotificationCenterRight) {
		return null;
	}

	return (
		<Stack display={isV2 ? "contents" : undefined}>
			<DashboardResolvingNowSection onEmptyChange={handleResolvingChange} />
			<DashboardUpcomingSection onEmptyChange={handleUpcomingChange} />
			<DashboardRecentSection onEmptyChange={handleRecentChange} />
		</Stack>
	);
};
